module.exports = __webpack_public_path__ + "static/img/step1@2x.8d18e754.png";